module.exports = __webpack_public_path__ + "img/icons-fill-implements.45df0516.svg";